import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlService } from '@services/datasources/url.service';
import { Observable, Observer } from 'rxjs';
import { IndustryDto } from 'app/@types/dto/industry-dto.model';

/**
 * Service holding the list of industries
 */
@Injectable({
    providedIn: 'root',
})
export class IndustryService {
    private industries: IndustryDto[] = [];

    constructor(private http: HttpClient, private urlService: UrlService) {}

    public get(): Observable<IndustryDto[]> {
        return new Observable((observer: Observer<IndustryDto[] | undefined>) => {
            if (this.industries.length === 0) {
                this.http.get<IndustryDto[]>(this.urlService.getIndustriesUrl()).subscribe({
                    next: (industries) => {
                        this.industries = industries;
                        observer.next(industries);
                        observer.complete();
                    },
                    error: (error) => {
                        observer.error('Error listing industries');
                        observer.complete();
                    },
                });
            } else {
                observer.next(this.industries);
                observer.complete();
            }
        });
    }
}
